import { Dropdown as UiBrickDropDown } from '@makemydeal/ui-bricks/dist/cox';
import type { DropDownProps, DropDownWrapperProps } from '@makemydeal/dr-ui-bricks-types';
import { DropdownWrapper } from './dropdown.style';

const Dropdown: React.FC<DropDownProps & DropDownWrapperProps> = ({
    options,
    name = '',
    value,
    label = '',
    disabled,
    onChange
}) => {
    return (
        <DropdownWrapper>
            <UiBrickDropDown
                label={label}
                options={options}
                onChange={onChange}
                disabled={disabled as boolean}
                name={name}
                value={value}
            />
        </DropdownWrapper>
    );
};

export default Dropdown;
